import axios from "axios";
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import firebase from 'firebase/compat/app';
const firestore=firebase.firestore


export class InviteService {
    /**
     * Join `groupId` with an invite code. The server derives the joining
     * student from the Firebase ID token sent here — it never trusts a
     * client-supplied artist id (security finding S04). Rejects with a
     * user-facing message.
     */
    static verifyCode = async (groupId: string, code: string): Promise<void> => {
        const user = firebase.auth().currentUser;
        if (!user) throw new Error("Please sign in to join a session.");
        const idToken = await user.getIdToken();
        try {
            await axios.post("/activateCode", { groupId, code }, {
                headers: { Authorization: `Bearer ${idToken}` },
            });
        } catch (error: any) {
            const status = error?.response?.status;
            const message = error?.response?.data?.message;
            if (status === 401) throw new Error("Your sign-in has expired. Please reload the page, sign in again and retry.");
            if (status === 429) throw new Error("Too many attempts. Please wait a few minutes and try again.");
            if ((status === 403 || status === 409) && typeof message === "string" && message !== "invalid code") {
                throw new Error(message.charAt(0).toUpperCase() + message.slice(1) + ".");
            }
            throw new Error("Invalid Code");
        }
    }
    static getInviteCode = (groupId: string) => new Promise<string>((resolve, reject) => {
        const db = firestore();
        db.collection("invites").doc(groupId).get().then((inviteDoc) => {
            const { code } = inviteDoc.data() || { code: undefined }
            code ? resolve(code) : reject();
        }).catch(reject)
    })

    /** Invitation emails for a group (admins + group owner only). */
    static getInvitedEmails = (groupId: string) => new Promise<string[]>((resolve, reject) => {
        const db = firestore();
        db.collection("groupInvites").doc(groupId).get().then((doc) => {
            const emails = (doc.data() || {}).emails;
            resolve(Array.isArray(emails) ? emails : []);
        }).catch(reject)
    })

    static setInvitedEmails = (groupId: string, emails: string[]) => {
        const db = firestore();
        return db.collection("groupInvites").doc(groupId).set({ groupId, emails }, { merge: true });
    }

    static setInviteCode = (groupId: string, ownerId: string, code: string) => new Promise<void>((resolve, reject) => {
        const db = firestore();
        db.collection("invites").doc(groupId).set({ code, groupId }).then(resolve)
            .catch(reject)
    })

}
